import React from 'react'
import { LazyLoadImage } from "react-lazy-load-image-component";
import fetImg1 from "../../assets/images/fet-svg/fet-img (2).svg";
import fetImg2 from "../../assets/images/fet-svg/fet-img (3).svg";
import fetImg3 from "../../assets/images/fet-svg/fet-img (4).svg";
import fetImg4 from "../../assets/images/fet-svg/fet-img (5).svg";
import fetImg5 from "../../assets/images/fet-svg/fet-img (6).svg";
import fetImg6 from "../../assets/images/fet-svg/fet-img (7).svg";
import fetImg7 from "../../assets/images/fet-svg/fet-img (8).svg";
import fetImg8 from "../../assets/images/fet-svg/fet-img (9).svg";
import fetImg9 from "../../assets/images/fet-svg/fet-img (10).svg";
import fetImg10 from "../../assets/images/fet-svg/fet-img (11).svg";
import fetImg11 from "../../assets/images/fet-svg/fet-img (12).svg";
import fetImg12 from "../../assets/images/fet-svg/fet-img (13).svg";
import fetImg13 from "../../assets/images/fet-svg/fet-img (14).svg";
import fetImg14 from "../../assets/images/fet-svg/fet-img (15).svg";
import fetImg15 from "../../assets/images/fet-svg/fet-img (16).svg";
import fetImg16 from "../../assets/images/fet-svg/fet-img (17).svg";
import fetImg17 from "../../assets/images/fet-svg/fet-img (18).svg";
import fetImg18 from "../../assets/images/fet-svg/fet-img (19).svg";
import fetImg19 from "../../assets/images/fet-svg/fet-img (20).svg";
import fetImg20 from "../../assets/images/fet-svg/fet-img (21).svg";
import fetImg21 from "../../assets/images/fet-svg/fet-img (22).svg";
import fetImg22 from "../../assets/images/fet-svg/fet-img (23).svg";
import fetImg23 from "../../assets/images/fet-svg/fet-img (1).svg";

const FetureSection = () => {
    const toolsImgSection1 = [
    { id: 1, img: fetImg1 },
    { id: 2, img: fetImg2 },
    { id: 3, img: fetImg3 },
    { id: 4, img: fetImg4 },
    { id: 5, img: fetImg5 },
    { id: 6, img: fetImg6 },
    { id: 7, img: fetImg7 },
    { id: 8, img: fetImg8 },
    { id: 9, img: fetImg9 },
  ];
  const toolsImgSection2 = [
    { id: 1, img: fetImg10 },
    { id: 2, img: fetImg11 },
    { id: 3, img: fetImg12 },
    { id: 4, img: fetImg13 },
    { id: 5, img: fetImg14 },
    { id: 6, img: fetImg15 },
    { id: 7, img: fetImg16 },
    { id: 8, img: fetImg17 },
  ];
  const toolsImgSection3 = [
    { id: 1, img: fetImg18 },
    { id: 2, img: fetImg19 },
    { id: 3, img: fetImg20 },
    { id: 4, img: fetImg21 },
    { id: 5, img: fetImg22 },
    { id: 6, img: fetImg23 },
  ];
  return (
    <>
<div className="feature-section overflow-hidden">
        <div className="container custom-container">
            <h1 className="web-heading-01 fw-bold mb-20 mb-sm-30 mb-md-4o mb-lg-50" data-aos="fade-up" data-aos-delay="300">
              Truly global with diverse <br /> courses.
            </h1>
          <div className="row align-items-center" data-aos="fade-up" data-aos-delay="900">
            <div className="col-12 col-xl-6 mb-23">
              <div className="feature-box d-flex justify-content-between flex-column flex-sm-row">
                <p className="mb-0 fw-normal py-20 py-sm-30 py-md-40 py-lg-50 ps-18 ps-sm-28 ps-md-38 ps-lg-46 pe-10 pe-sm-15 pe-md-20 pe-lg-25">
                  Welcome to EGWB, your go-to online education platform where
                  knowledge meets convenience.
                </p>
                <div className="feature-stats-box px-16 px-sm-22 px-md-26 px-lg-31 pt-15 pt-sm-20 pt-md-30 pt-lg-40 pb-20 pb-sm-30 pb-md-40 pb-lg-50 d-flex flex-column text-center text-white">
                  <h1 className="web-heading-01 fw-bold text-white mb-10">
                    50+
                  </h1>
                  <p className="mb-0 fw-normal">Courses</p>
                </div>
              </div>
            </div>
            <div className="col-12 col-xl-6 mb-23">
              <ul className="nav gap-3 justify-content-end nav-1">
                {toolsImgSection1.map((tool) => (
                  <li key={tool.id}>
                    <img
                      src={tool.img}
                      alt={`Tool ${tool.id}`}
                      className="img-fluid"
                    />
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="row align-items-center" data-aos="fade-up" data-aos-delay="1200">
            <div className="col-12 col-xl-7 mb-23">
              <div className="feature-box d-flex justify-content-between flex-column flex-sm-row">
                <p className="mb-0 fw-normal py-20 py-sm-30 py-md-40 py-lg-50 ps-18 ps-sm-28 ps-md-38 ps-lg-46 pe-10 pe-sm-15 pe-md-20 pe-lg-25">
                  At EGWB, we offer a wide range of courses designed to enhance
                  your skills and knowledge, all from the comfort of your home.
                </p>
                <div className="feature-stats-box px-16 px-sm-22 px-md-26 px-lg-31 pt-15 pt-sm-20 pt-md-30 pt-lg-40 pb-20 pb-sm-30 pb-md-40 pb-lg-50 d-flex flex-column text-center text-white">
                  <h1 className="web-heading-01 fw-bold text-white mb-10">
                    1m+
                  </h1>
                  <p className="mb-0 fw-normal">Users</p>
                </div>
              </div>
            </div>
            <div className="col-12 col-xl-5 mb-23">
              <ul className="nav gap-3 nav-2">
                {toolsImgSection2.map((tool) => (
                  <li key={tool.id}>
                    <img
                      src={tool.img}
                      alt={`Tool ${tool.id}`}
                      className="img-fluid"
                    />
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="row align-items-center" data-aos="fade-up" data-aos-delay="1500">
            <div className="col-12 col-xl-9 mb-23">
              <div className="feature-box d-flex justify-content-between flex-column flex-sm-row">
                <p className="mb-0 fw-normal py-20 py-sm-30 py-md-40 py-lg-50 ps-18 ps-sm-28 ps-md-38 ps-lg-46 pe-10 pe-sm-15 pe-md-20 pe-lg-25">
                  Join us at EGWB, where you can explore diverse subjects,
                  engage with expert instructors, and enjoy a flexible learning
                  experience tailored to your needs.
                </p>
                <div className="feature-stats-box px-16 px-sm-22 px-md-26 px-lg-31 pt-15 pt-sm-20 pt-md-30 pt-lg-40 pb-20 pb-sm-30 pb-md-40 pb-lg-50 d-flex flex-column text-center text-white">
                  <h1 className="web-heading-01 fw-bold text-white mb-10">
                    100+
                  </h1>
                  <p className="mb-0 fw-normal">Instructors</p>
                </div>
              </div>
            </div>
            <div className="col-12 col-xl-3 mb-23">
              <ul className="nav gap-3 nav-3">
                {toolsImgSection3.map((tool) => (
                  <li key={tool.id}>
                    <img
                      src={tool.img}
                      className="img-fluid"
                      alt={`Tool ${tool.id}`}
                    />
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default FetureSection